export default "__VITE_ASSET__DqlNeRjg__"